export default __webpack_public_path__ + "static/media/IF_MyLeadershipStrengths_StrengthDesc_04.d4cd56cf.jpg";